import React, { Component, Fragment } from 'react';
import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import authService from './AuthorizeService';
import { ApplicationPaths } from './ApiAuthorizationConstants';

export class LoginMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: false,
      userName: null,
      type: props.type
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async GetMessagesCount() {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{userApiUrl}}api/users/messagescount`, {
      method: "GET",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) {
      return;
    }
    const count = await response.text();
    this.setState(prevState => ({...prevState, messagesCount: parseInt(count)}));
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState({
      isAuthenticated,
      userName: user && user.name
    });
    console.log("isAuth:" + isAuthenticated);
    if (isAuthenticated) {
      this.GetMessagesCount();
    }
  }

  render() {
    const { isAuthenticated, userName } = this.state;
    if (!isAuthenticated) {
      const registerPath = `${ApplicationPaths.Register}`;
      const loginPath = `${ApplicationPaths.Login}`;
      return this.anonymousView(registerPath, loginPath);
    } else {
      const profilePath = `${ApplicationPaths.Profile}`;
      const logoutPath = `${ApplicationPaths.LogOut}`;
      const logoutState = { local: true };
      return this.authenticatedView(userName, profilePath, logoutPath, logoutState);
    }
  }

  authenticatedView(userName, profilePath, logoutPath, logoutState) {
    return this.state.type==="logintext"?<></>:<Fragment>
      <NavItem className={"nav authenticated" + this.state.type}>
        <NavLink tag={Link} className="text-dark userlogout" to={profilePath}><span class="user"></span>{this.state.messagesCount?<span class="messages">{this.state.messagesCount.toString()}</span>:<></>}</NavLink>
      </NavItem>
      <NavItem className={"nav authenticated" + this.state.type}>
        <NavLink replace tag={Link} className="text-dark userlogout" to={logoutPath} state={logoutState}><span class="logout"></span></NavLink>
      </NavItem>
    </Fragment>;
  }

  anonymousView(registerPath, loginPath) {
    return this.state.type === "logintext" ?
      <Fragment><NavItem className={"anonymous" + this.state.type}>
        <NavLink tag={Link} className="text-dark" to={registerPath}>Регистрация</NavLink>
      </NavItem>
      <NavItem className={"anonymous" + this.state.type}>
        <NavLink tag={Link} className="text-dark" to={loginPath}>Вход</NavLink>
      </NavItem></Fragment> :
      <Fragment><NavItem className={"nav anonymous" + this.state.type}>
        <NavLink tag={Link} className="text-dark userlogout" to={registerPath}><span class="register"></span></NavLink>
      </NavItem>
      <NavItem className={"nav anonymous" + this.state.type}>
        <NavLink tag={Link} className="text-dark userlogout" to={loginPath}><span class="login"></span></NavLink>
      </NavItem></Fragment>;
  }
}
